@if (feeConfig && feeAmounts) {
  <div class="dropdown-container">
    <div
      class="togglable-header"
      (click)="toggle()"
      (keydown.space)="toggle()"
      (keydown.enter)="toggle()"
      tabindex="0"
      >
      <svg-icon src="assets/icons/chevron-down.svg" [svgStyle]="{ 'width.px':18, 'transform': toggled ? 'rotate(180deg)' : '' }"></svg-icon>
      <div class="type">{{ 'modal.feeConfigs.opfFeeImpl.' + opfFeeImplVariant + '.regularEntryFeeHeader' | translate }}</div>
      <div class="amount">{{ feeConfig.entryFee * 100 | number:'1.0-2' }} %</div>
    </div>
    <div class="toggled-info" [ngClass]="{ 'toggled-info--visible': toggled }" data-cy="fee-config-modal-regular-expanded">
      <div class="values-wrapper">
        <div class="fees-row">
          <div class="fee-desc">{{ 'modal.feeConfigs.opfFeeImpl.' + opfFeeImplVariant + '.regularEntryFeeType' | translate }}</div>
          <div class="fee-value">{{ 'consultClientDetail.feeTypes.' + feeConfig.entryFeeType | translate }}</div>
        </div>
        <div class="fees-row">
          <div class="fee-desc">{{ 'modal.feeConfigs.opfFeeImpl.' + opfFeeImplVariant + '.totalEntryFee' | translate }}</div>
          <div class="fee-value">
            {{ feeAmounts.totalEntryFee | price:'CZK' }}
            @if (feeConfig.entryDiscountRegular) {
              <div class="fee-value-sale">
                {{ 'modal.feeConfigs.opfFeeImpl.' + opfFeeImplVariant + '.includingSalePart1' | translate }}
                {{ feeConfig.entryDiscountRegular * 100 | number:'1.0-2' }} %
                {{ 'modal.feeConfigs.opfFeeImpl.' + opfFeeImplVariant + '.includingSalePart2' | translate }}
              </div>
            }
          </div>
        </div>
        <div class="fees-row">
          <div class="fee-desc">{{ 'modal.feeConfigs.opfFeeImpl.' + opfFeeImplVariant + '.alreadyPaid' | translate }}</div>
          <div class="fee-value">
            {{ (feeAmounts.withVat ? feeAmounts.entryFeeAlreadyPaidWithVat : feeAmounts.entryFeeAlreadyPaid) | price:'CZK' }}
            @if (feeAmounts.vatAlreadyPaid) {
              <div class="fee-value-sale">
                {{ 'modal.feeConfigs.opfFeeImpl.' + opfFeeImplVariant + '.alreadyPaidVATPart1' | translate }}
                {{ feeAmounts.entryFeeAlreadyPaid | price:'CZK' }}
                {{ 'modal.feeConfigs.opfFeeImpl.' + opfFeeImplVariant + '.alreadyPaidVATPart2' | translate }}
                {{ feeAmounts.vatAlreadyPaid | price:'CZK' }}
                {{ 'modal.feeConfigs.opfFeeImpl.' + opfFeeImplVariant + '.alreadyPaidVATPart3' | translate }}
              </div>
            }
          </div>
        </div>
        <div class="fees-row">
          <div class="fee-desc" data-cy="fee-config-modal-unpaid-fee">
            @if (hasVat) {
              {{ 'modal.feeConfigs.opfFeeImpl.' + opfFeeImplVariant + '.unpaidFee_withVat' | translate }}
            } @else {
              {{ 'modal.feeConfigs.opfFeeImpl.' + opfFeeImplVariant + '.unpaidFee_withoutVat' | translate }}
            }
          </div>
          <div class="fee-value">
            {{ feeAmounts.unpaidAmountWithVat | price:'CZK' }}
          </div>
        </div>
      </div>
      @if (feeConfig.entryFee > 0) {
        <div class="fee-info">
          {{ 'modal.feeConfigs.opfFeeImpl.' + opfFeeImplVariant + '.entryFeeInfoPart1' | translate }}
          <b>{{ 'modal.feeConfigs.opfFeeImpl.' + opfFeeImplVariant + '.entryFeeInfoPart2Bold' | translate }}
          {{ feeAmounts.totalRegularAmount | price:'CZK' }}</b>{{ 'modal.feeConfigs.opfFeeImpl.' + opfFeeImplVariant + '.entryFeeInfoPart3' | translate }}<b>{{ 'modal.feeConfigs.opfFeeImpl.' + opfFeeImplVariant + '.entryFeeInfoPart4Bold' | translate }}
          {{ feeAmounts.totalTargetRegularAmount | price:'CZK' }}{{ 'modal.feeConfigs.opfFeeImpl.' + opfFeeImplVariant + '.entryFeeInfoPart5Bold' | translate }}
        {{ feeAmounts.remainingAmountToReachTargetActual | price:'CZK' }}</b>{{ 'modal.feeConfigs.opfFeeImpl.' + opfFeeImplVariant + '.entryFeeInfoPart6' | translate }}
      </div>
      }
  </div>
</div>
}
